export const FAST_PAYMENTS_ROUTE = 'pay';
export const FAST_PAYMENT_CONFIRMATION_PARAMETRIZED = 'confirmation/:id';
export const FAST_PAYMENT_CONFIRMATION = 'confirmation';
